// eslint-disable-next-line no-unused-vars
import {$} from '../util';

class IframeBrowser {
  constructor(setup, _$container, navi_on) {
    if (typeof setup !== "object") {
      console.log('// WARNING: arg0 is non-object');
    }
    this.setup = setup || {};
    this.id = this.setup.id;
    this.url = '';
    this.iframe = this.createIframe(this.id);
    this.$html = $(document.documentElement);
    this.$wrapper = $('<div class="iframe-browser-wrapper"></div>');

    if (_$container instanceof $ !== true) {
      _$container = $('<div class="iframe-browser" id="' + this.id + '-cnt"></div>');
    }

    this.$container = _$container.append(this.$wrapper);
    this.$iframe = $(this.iframe).on('load', (e) => {
      void (typeof this.setup.onLoad === "function" && this.setup.onLoad());
    });

    if (navi_on !== false) {
      this.$navigation = this.createNavigation().appendTo(this.$wrapper);
    }

    this.$wrapper.append(this.iframe);

  };

  reateNavigation(id) {
    return $(
      '<div class="navigation clearfix">' +
        // '<a class="btn-back"></a>'+
        // '<a class="btn-next"></a>'+
        '<a class="btn-reload"></a>' +
        '<a class="btn-home"></a>' +
      '</div>'
    ).on('touchstart click', 'a', (e) => {
      e.stopPropagation(); e.preventDefault();
      switch (e.currentTarget.className) {
        case 'btn-back': this.iframe.contentWindow.history.back(); break;
        case 'btn-next': this.iframe.contentWindow.history.forward(); break;
        case 'btn-reload':
        case 'btn-home': this.setUrl(this.url); break;
      }
    });
  };

  createIframe(id) {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('id', id);
    iframe.setAttribute('name', 'iframe_' + id);
    iframe.setAttribute('class', 'iframe-browser');
    // iframe.setAttribute('referrerpolicy', 'unsafe-url');
    iframe.setAttribute('scrolling', 'auto');
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe
    if (!this.setup.unsafe) {
      iframe.setAttribute('sandbox', 'allow-same-origin allow-scripts allow-forms allow-pointer-lock allow-modals');
      iframe.setAttribute('referrerpolicy', 'unsafe-url');
    }
    iframe.setAttribute('marginheight', '0');
    iframe.setAttribute('marginwidth', '0');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('src', '');
    return iframe;
  };

  reload() {
    this.setUrl(this.url);
  };

  setUrl(url) {
    this.iframe.setAttribute('src', (this.url = url));
  };

  detach() {
    this.$container.detach();
  };

  attach($to) {
    this.$container.appendTo($to);
  };

  getElem(DOMRef) {
    return DOMRef ? this.$container[0] : this.$container;
  };

}



export default IframeBrowser;
